import { createAction } from '@reduxjs/toolkit';
import { withPayloadType } from 'utils';

export const revokeInvitationStart = createAction(
  'REVOKE_INVITATION::START',
  withPayloadType<{ id: string; organizationId: string }>(),
);
